import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setShape, setColor, setMainType, setSize } from '../../../../../store/actions/resultInfo'
import { getCall, baseUrl } from '../../../../../helpers/api'
import queryString from 'query-string'
import Card from '../cards/card'
import CardContainer from '../card-container/cardContainer'
import CardHolder from '../../card-holder/cardHolder'
import CardTitle from '../../card-title/card-title'


class ResultCardsExample extends Component {

    constructor(props) {
        super(props)
        this.state = {
            results: []
        }
    }

    async componentDidMount() {
        const values = queryString.parse(this.props.location.search)
        setMainType(values.t)
        setColor(values.c)
        setShape(values.sh)
        setSize(values.si)
        const results = await getCall("/resultCicek/getWithParams", { values })
        await this.setState({ results: results.data })

    }

    render() {
        return (
            <CardContainer>
                <CardTitle title="Bitkiniz Bunlardan Hangisi" />

                <CardHolder>
                    {this.state.results.map((r, index) => (
                        <Card key={index} history={this.props.history} id={r._id} image={baseUrl + r.image} name={r.name} />
                    ))}
                
                </CardHolder>
            </CardContainer>
        )
    }
}

export default connect((store) => ({ resultInfo: store.resultInfo }), {})(ResultCardsExample)
